// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"20e29145","845":"84febad0"}[chunkId] + ".chunk.js";
};